import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/col/index.js
// module id = 285
// module chunks = 0